import { Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';

import './MarketShareDropdown.scss';

const marketShareDropdown = ({ title, items, selected, onChange }) => {

    if (!items?.length) {
        return null;
    }

    return <div className='marketShareDropdown'>
        <p className='title'>{title}</p>
        <Dropdown>
            <Dropdown.Toggle>
                {selected}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {items.map((value, index) => <Dropdown.Item active={selected === value} key={index} onClick={() => onChange(value)}>{value}</Dropdown.Item>)}
            </Dropdown.Menu>
        </Dropdown>
    </div>;
};

marketShareDropdown.propTypes = {
    title: PropTypes.string,
    items: PropTypes.array,
    selected: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

export default marketShareDropdown;
